(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["skin-quiz-v1"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-ptq-root]');
    roots.forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      document.documentElement.classList.add('ptq-focus-mode');

      const config = JSON.parse(root.querySelector('[data-ptq-config]').textContent);
      const panel = root.querySelector('.ptq__panel');
      const stage = root.querySelector('[data-ptq-stage]');
      const back = root.querySelector('[data-ptq-back]');
      const stepText = root.querySelector('[data-ptq-step]');
      const progress = root.querySelector('[data-ptq-progress]');
      const progressFill = progress.querySelector('span');
      const sticky = root.querySelector('[data-ptq-sticky]');
      const stickyPrice = root.querySelector('[data-ptq-sticky-price]');
      const stickyLink = root.querySelector('[data-ptq-sticky-link]');
      const scrollToQuizTop = (element = root) => {
        const headerClearance = window.innerWidth <= 620 ? 118 : 124;
        window.scrollTo({ top: Math.max(0, element.getBoundingClientRect().top + window.scrollY - headerClearance), behavior: 'auto' });
      };

      const state = {
        concerns: [],
        skin_type: null,
        breakout_type: null,
        dark_mark_pattern: null,
        sensitivity_level: null,
        avoid_ingredients: [],
        country_code: null,
        country_name: null
      };

      const details = {
        goal: {
          phase: 1,
          key: 'concerns',
          multi: true,
          max: 2,
          title: 'What would you like help with?',
          copy: 'Choose up to two concerns. If acne and marks both apply, select both so your routine addresses them together.',
          choices: [
            ['Fade dark spots or acne marks', 'dark_spots'],
            ['Clear active breakouts', 'active_breakouts'],
            ['Even out dull or uneven tone', 'uneven_tone'],
            ['I am just maintaining my skin', 'maintenance'],
            ['I am not sure yet', 'not_sure']
          ]
        },
        skin: {
          phase: 2,
          key: 'skin_type',
          title: 'What is your skin type?',
          copy: 'If you are between two, choose the one that describes your skin most days.',
          choices: [['Oily', 'oily'], ['Dry', 'dry'], ['Combination', 'combination'], ['Normal', 'normal'], ['Sensitive or reactive', 'sensitive'], ['Not sure', 'not_sure']]
        },
        breakout: {
          phase: 3,
          key: 'breakout_type',
          title: 'What type of breakouts are you dealing with?',
          copy: 'Cystic acne is deep, painful, red, and inflamed, rather than surface-level whiteheads or blackheads.',
          choices: [['Mostly surface pimples or whiteheads', 'surface'], ['Deep, painful, cystic breakouts', 'cystic'], ['Occasional breakouts only', 'occasional'], ['I am not dealing with active breakouts right now', 'none']]
        },
        marks: {
          phase: 3,
          key: 'dark_mark_pattern',
          title: 'How many dark marks are you focused on?',
          copy: 'This helps us choose the right level of support without overcomplicating your routine.',
          choices: [['1 to 5 individual spots', 'one_to_five'], ['More than 5 spots', 'more_than_five'], ['Larger areas of uneven pigment', 'larger_areas'], ['I am not sure', 'not_sure']]
        },
        sensitivity: {
          phase: 4,
          key: 'sensitivity_level',
          title: 'How does your skin usually react to new products?',
          copy: 'This helps us decide how slowly to introduce your routine.',
          choices: [['My skin usually adjusts well', 'low'], ['I can be a little sensitive', 'medium'], ['My skin stings, burns, or reacts easily', 'high'], ['I am not sure', 'not_sure']]
        },
        exclusions: {
          phase: 5,
          key: 'avoid_ingredients',
          multi: true,
          title: 'Do any of these safety considerations apply?',
          copy: 'Select every option that applies. This keeps incompatible ingredients and retinoids out of your recommendation.',
          choices: [['I am pregnant or breastfeeding', 'pregnant_breastfeeding'], ['I use prescription tretinoin or another retinoid', 'prescription_retinoid'], ['Wheat germ oil allergy or sensitivity', 'wheat_germ_oil'], ['Citric acid allergy or sensitivity', 'citric_acid'], ['Salicylic acid allergy or sensitivity', 'salicylic_acid'], ['None of these', 'none'], ['I am not sure', 'not_sure']]
        },
        country: { phase: 6, title: 'Where are you located?', copy: 'Your location helps us show the right shopping or service option.' },
        lead: { phase: 7, title: 'Almost there. See your match and unlock 25% off.', copy: 'Enter your details to see your routine. Choose how you would like to hear from us.' }
      };

      const countryCodes = ['AD','AE','AF','AG','AI','AL','AM','AO','AQ','AR','AS','AT','AU','AW','AX','AZ','BA','BB','BD','BE','BF','BG','BH','BI','BJ','BL','BM','BN','BO','BQ','BR','BS','BT','BV','BW','BY','BZ','CA','CC','CD','CF','CG','CH','CI','CK','CL','CM','CN','CO','CR','CU','CV','CW','CX','CY','CZ','DE','DJ','DK','DM','DO','DZ','EC','EE','EG','EH','ER','ES','ET','FI','FJ','FK','FM','FO','FR','GA','GB','GD','GE','GF','GG','GH','GI','GL','GM','GN','GP','GQ','GR','GS','GT','GU','GW','GY','HK','HM','HN','HR','HT','HU','ID','IE','IL','IM','IN','IO','IQ','IR','IS','IT','JE','JM','JO','JP','KE','KG','KH','KI','KM','KN','KP','KR','KW','KY','KZ','LA','LB','LC','LI','LK','LR','LS','LT','LU','LV','LY','MA','MC','MD','ME','MF','MG','MH','MK','ML','MM','MN','MO','MP','MQ','MR','MS','MT','MU','MV','MW','MX','MY','MZ','NA','NC','NE','NF','NG','NI','NL','NO','NP','NR','NU','NZ','OM','PA','PE','PF','PG','PH','PK','PL','PM','PN','PR','PS','PT','PW','PY','QA','RE','RO','RS','RU','RW','SA','SB','SC','SD','SE','SG','SH','SI','SJ','SK','SL','SM','SN','SO','SR','SS','ST','SV','SX','SY','SZ','TC','TD','TF','TG','TH','TJ','TK','TL','TM','TN','TO','TR','TT','TV','TW','TZ','UA','UG','UM','US','UY','UZ','VA','VC','VE','VG','VI','VN','VU','WF','WS','YE','YT','ZA','ZM','ZW'];
      const countryNames = typeof Intl.DisplayNames === 'function' ? new Intl.DisplayNames([navigator.language || 'en'], { type: 'region' }) : null;
      const countries = countryCodes.map((code) => ({ code, name: countryNames ? countryNames.of(code) : code })).sort((a, b) => a.name.localeCompare(b.name));

      let current = 'goal';
      let screenHistory = [];
      let resultObserver;

      const escapeHtml = (value) => String(value || '').replace(/[&<>"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[character]));
      const money = (value) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);

      function positionCurrentStep() {
        if (!screenHistory.length) return;
        requestAnimationFrame(() => {
          scrollToQuizTop(panel);
        });
      }

      function sequenceAfter(screen) {
        if (screen === 'goal') return 'skin';
        if (screen === 'skin') {
          if (state.concerns.includes('active_breakouts')) return 'breakout';
          if (state.concerns.includes('dark_spots') || state.concerns.includes('not_sure')) return 'marks';
          return 'sensitivity';
        }
        if (screen === 'breakout') return state.concerns.includes('dark_spots') ? 'marks' : 'sensitivity';
        if (screen === 'marks') return 'sensitivity';
        if (screen === 'sensitivity') return 'exclusions';
        if (screen === 'exclusions') return 'country';
        if (screen === 'country') return 'lead';
        return null;
      }

      function setProgress() {
        const total = 6
          + (state.concerns.includes('active_breakouts') ? 1 : 0)
          + (state.concerns.includes('dark_spots') || state.concerns.includes('not_sure') ? 1 : 0);
        const position = Math.min(screenHistory.length + 1, total);
        stepText.textContent = `Step ${position} of ${total}`;
        progress.setAttribute('aria-valuemax', String(total));
        progress.setAttribute('aria-valuenow', String(position));
        progressFill.style.width = `${(position / total) * 100}%`;
        back.hidden = screenHistory.length === 0;
      }

      function renderQuestion(name) {
        root.classList.remove('ptq--lead');
        current = name;
        const question = details[name];
        setProgress(question.phase);
        const selected = question.multi ? state[question.key] : state[question.key];
        stage.innerHTML = `
          <fieldset class="ptq__question">
            <legend>
              <span class="ptq__question-title">${escapeHtml(question.title)}</span>
              <span class="ptq__question-copy">${escapeHtml(question.copy)}</span>
            </legend>
            <div class="ptq__choices">
              ${question.choices.map(([label, value]) => {
                const isSelected = question.multi ? selected.includes(value) : selected === value;
                return `<button class="ptq__choice${question.multi ? ' ptq__choice--multi' : ''}" type="button" data-value="${value}" aria-pressed="${isSelected}">${escapeHtml(label)}</button>`;
              }).join('')}
            </div>
            <p class="ptq__error" data-ptq-error hidden>Please choose an answer to continue.</p>
            <div class="ptq__controls"><button class="ptq__action" type="button" data-ptq-continue ${question.multi ? '' : selected ? '' : 'disabled'}>Continue →</button></div>
          </fieldset>`;

        const continueAction = stage.querySelector('[data-ptq-continue]');
        stage.querySelectorAll('[data-value]').forEach((choice) => {
          choice.addEventListener('click', () => {
            const value = choice.dataset.value;
            if (question.multi) {
              let values = [...state[question.key]];
              const exclusiveValues = question.key === 'concerns' ? ['maintenance', 'not_sure'] : ['none', 'not_sure'];
              if (exclusiveValues.includes(value)) values = values.includes(value) ? [] : [value];
              else {
                values = values.filter((item) => !exclusiveValues.includes(item));
                values = values.includes(value) ? values.filter((item) => item !== value) : [...values, value].slice(0, question.max || 99);
              }
              state[question.key] = values;
              stage.querySelectorAll('[data-value]').forEach((item) => item.setAttribute('aria-pressed', String(values.includes(item.dataset.value))));
              continueAction.disabled = values.length === 0;
            } else {
              state[question.key] = value;
              stage.querySelectorAll('[data-value]').forEach((item) => item.setAttribute('aria-pressed', String(item === choice)));
              continueAction.disabled = false;
            }
          });
        });
        continueAction.addEventListener('click', advance);
        stage.querySelector('[data-value]')?.focus({ preventScroll: true });
        positionCurrentStep();
      }

      function renderCountry() {
        root.classList.remove('ptq--lead');
        current = 'country';
        setProgress(6);
        stage.innerHTML = `
          <div class="ptq__question">
            <div class="ptq__question-title">${details.country.title}</div>
            <div class="ptq__question-copy">${details.country.copy}</div>
            <div class="ptq__field-grid">
              <div class="ptq__field-row">
                <label for="ptq-country-${root.dataset.sectionId}">Country or region</label>
                <input class="ptq__field" id="ptq-country-${root.dataset.sectionId}" list="ptq-countries-${root.dataset.sectionId}" autocomplete="country-name" value="${escapeHtml(state.country_name || '')}" placeholder="Start typing your country" data-ptq-country>
                <datalist id="ptq-countries-${root.dataset.sectionId}">${countries.map((country) => `<option value="${escapeHtml(country.name)}"></option>`).join('')}</datalist>
              </div>
            </div>
            <p class="ptq__error" data-ptq-error hidden>Please choose a country from the list.</p>
            <div class="ptq__controls"><button class="ptq__action" type="button" data-ptq-continue ${state.country_code ? '' : 'disabled'}>Continue →</button></div>
          </div>`;
        const input = stage.querySelector('[data-ptq-country]');
        const continueAction = stage.querySelector('[data-ptq-continue]');
        input.addEventListener('input', () => {
          const match = countries.find((country) => country.name.toLowerCase() === input.value.trim().toLowerCase());
          state.country_code = match ? match.code : null;
          state.country_name = match ? match.name : null;
          continueAction.disabled = !match;
        });
        continueAction.addEventListener('click', advance);
        input.focus({ preventScroll: true });
        positionCurrentStep();
      }

      function renderLead() {
        root.classList.add('ptq--lead');
        current = 'lead';
        setProgress(7);
        stage.innerHTML = `
          <form class="ptq__question" data-ptq-lead novalidate>
            <div class="ptq__question-title">${details.lead.title}</div>
            <div class="ptq__question-copy">${details.lead.copy}</div>
            <div class="ptq__field-grid">
              <div class="ptq__field-row"><label for="ptq-name-${root.dataset.sectionId}">Full name</label><input class="ptq__field" id="ptq-name-${root.dataset.sectionId}" name="full_name" autocomplete="name" required></div>
              <div class="ptq__field-row"><label for="ptq-email-${root.dataset.sectionId}">Email</label><input class="ptq__field" id="ptq-email-${root.dataset.sectionId}" name="email" type="email" autocomplete="email" required></div>
              <div class="ptq__field-row"><label for="ptq-phone-${root.dataset.sectionId}">Phone <span class="ptq__hint">optional</span></label><input class="ptq__field" id="ptq-phone-${root.dataset.sectionId}" name="phone" type="tel" autocomplete="tel" inputmode="tel"></div>
              <input name="website" tabindex="-1" autocomplete="off" aria-hidden="true" hidden>
              <label class="ptq__check"><input type="checkbox" name="email_consent"><span class="ptq__check-box" aria-hidden="true"></span><span>Email me skincare guidance, product updates, and offers. Unsubscribe anytime.</span></label>
              <label class="ptq__check"><input type="checkbox" name="sms_consent"><span class="ptq__check-box" aria-hidden="true"></span><span>Text me skincare guidance and offers. Consent is not a condition of purchase. Msg &amp; data rates may apply; reply STOP to cancel.</span></label>
            </div>
            <p class="ptq__error" data-ptq-error hidden>Please enter your full name and a valid email address.</p>
            <div class="ptq__controls"><button class="ptq__action ptq__action--green" type="submit">Show my match →</button></div>
          </form>`;
        const form = stage.querySelector('[data-ptq-lead]');
        const phone = form.elements.phone;
        const smsConsent = form.elements.sms_consent;
        const syncSmsAvailability = () => {
          smsConsent.disabled = !phone.value.trim();
          if (smsConsent.disabled) smsConsent.checked = false;
        };
        phone.addEventListener('input', syncSmsAvailability);
        syncSmsAvailability();
        form.addEventListener('submit', (event) => {
          event.preventDefault();
          if (!form.elements.full_name.validity.valid || !form.elements.email.validity.valid) {
            stage.querySelector('[data-ptq-error]').hidden = false;
            (form.elements.full_name.validity.valid ? form.elements.email : form.elements.full_name).focus();
            return;
          }
          if (form.elements.sms_consent.checked && !form.elements.phone.value.trim()) {
            stage.querySelector('[data-ptq-error]').textContent = 'Enter a phone number to receive text messages.';
            stage.querySelector('[data-ptq-error]').hidden = false;
            form.elements.phone.focus();
            return;
          }
          finish(form);
        });
        positionCurrentStep();
      }

      function advance() {
        const next = sequenceAfter(current);
        if (!next) return;
        screenHistory.push(current);
        if (next === 'country') renderCountry();
        else if (next === 'lead') renderLead();
        else renderQuestion(next);
      }

      back.addEventListener('click', () => {
        const previous = screenHistory.pop();
        if (!previous) return;
        if (previous === 'country') renderCountry();
        else if (previous === 'lead') renderLead();
        else renderQuestion(previous);
      });

      function buildResult(answers) {
        const concerns = Array.isArray(answers.concerns) ? answers.concerns : [answers.primary_goal].filter(Boolean);
        const hasAcne = concerns.includes('active_breakouts') && answers.breakout_type !== 'none';
        const hasMarks = concerns.includes('dark_spots') || concerns.includes('not_sure');
        const lane = hasAcne && hasMarks ? 'combined' : hasAcne ? 'acne' : hasMarks ? 'dark_spots' : concerns.includes('maintenance') ? 'maintenance' : 'tone';
        const exclusions = answers.avoid_ingredients || [];
        const avoidRetinoids = exclusions.includes('pregnant_breastfeeding') || exclusions.includes('prescription_retinoid');
        const notes = [];
        const sensitiveSwap = answers.skin_type === 'sensitive' || answers.sensitivity_level === 'high' || exclusions.includes('salicylic_acid');
        const scores = Object.fromEntries(Object.keys(config.products).map((key) => [key, 0]));
        const score = (key, amount) => { scores[key] = (scores[key] || 0) + amount; };

        if (hasAcne && answers.breakout_type === 'cystic' && !sensitiveSwap) score('clear_marks_bar', 9);
        else if (sensitiveSwap || ['dry', 'normal'].includes(answers.skin_type) || concerns.includes('maintenance')) score('sensitive_soap', 7);
        else score('exfoliating_cleanser', 7);

        if (hasAcne) {
          score('clarifying_gel', 10);
          if (answers.breakout_type !== 'occasional') score('purifying_toner', 5);
          score('exfoliating_cleanser', 3);
        }
        if (hasMarks) {
          if (answers.dark_mark_pattern === 'one_to_five') score(sensitiveSwap ? 'spot_eraser' : 'spot_treatment', 10);
          else score(sensitiveSwap ? 'spot_eraser' : 'resurfacing_creme', 10);
          score('revitalizing_serum', 3);
        }
        if (concerns.includes('uneven_tone')) {
          score(sensitiveSwap ? 'spot_eraser' : 'refining_creme', 9);
          score('revitalizing_serum', 6);
        }
        if (concerns.includes('maintenance')) {
          score('miracle_moisturizer', 9);
          score('revitalizing_serum', 6);
        }
        if (concerns.includes('not_sure')) {
          score('spot_eraser', 7);
          score('miracle_moisturizer', 5);
        }

        if (sensitiveSwap) notes.push('Best for sensitive skin: we selected the gentler route and recommend introducing one product at a time.');
        const blocked = new Set();
        if (exclusions.includes('wheat_germ_oil')) blocked.add('clarifying_gel');
        if (exclusions.includes('citric_acid')) ['resurfacing_creme', 'refining_creme'].forEach((key) => blocked.add(key));
        if (exclusions.includes('salicylic_acid')) ['exfoliating_cleanser', 'clear_marks_bar'].forEach((key) => blocked.add(key));
        if (avoidRetinoids) ['resurfacing_creme', 'refining_creme', 'spot_treatment'].forEach((key) => blocked.add(key));
        if (sensitiveSwap) blocked.add('spot_treatment');
        if (hasMarks && (avoidRetinoids || exclusions.includes('citric_acid'))) score('spot_eraser', 12);
        const activeRemoved = (exclusions.includes('wheat_germ_oil') && scores.clarifying_gel >= 9)
          || (exclusions.includes('citric_acid') && ['resurfacing_creme', 'refining_creme'].some((key) => scores[key] >= 9))
          || (exclusions.includes('salicylic_acid') && ['exfoliating_cleanser', 'clear_marks_bar'].some((key) => scores[key] >= 9))
          || (avoidRetinoids && ['resurfacing_creme', 'refining_creme', 'spot_treatment'].some((key) => scores[key] >= 9));
        if (avoidRetinoids) notes.push('We removed Perfec-Tone retinoid products from this routine based on your safety answer.');
      if (exclusions.includes('prescription_retinoid')) notes.push("Using prescription tretinoin? Discuss your skin goals and the Perfec-Tone products you're considering with your prescribing clinician before starting them. We don't recommend pairing our treatment actives with tretinoin or planning alternate nights. Please don't stop or change your prescription to start our products.");
        if (lane === 'combined') {
          const clarifyingIsUsable = !blocked.has('clarifying_gel') && config.products.clarifying_gel?.available;
          if (clarifyingIsUsable) {
            score('clarifying_gel', 16);
            blocked.add('purifying_toner');
          } else {
            score('purifying_toner', 16);
          }
          let markTreatment = 'spot_eraser';
          if (!sensitiveSwap && !avoidRetinoids && answers.dark_mark_pattern === 'one_to_five' && !blocked.has('spot_treatment')) markTreatment = 'spot_treatment';
          else if (!sensitiveSwap && !avoidRetinoids && answers.dark_mark_pattern !== 'one_to_five' && !blocked.has('resurfacing_creme')) markTreatment = 'resurfacing_creme';
          score(markTreatment, 15);
          notes.push('Your three-product plan reserves one step for cleansing, one for active breakouts, and one for dark marks. Purifying Toner and Clarifying Gel are not paired in this streamlined routine.');
        }
        if (exclusions.includes('not_sure')) notes.push('Please review each linked ingredient list before beginning your routine.');
        const importantUnavailable = Object.entries(scores)
          .filter(([key, value]) => value >= 9 && !blocked.has(key) && config.products[key]?.variant && !config.products[key].available)
          .sort((a, b) => b[1] - a[1]);
        const replacementChains = {
          spot_treatment: ['resurfacing_creme', 'refining_creme', 'spot_eraser'],
          resurfacing_creme: ['refining_creme', 'spot_eraser'],
          refining_creme: ['spot_eraser'],
          spot_eraser: ['refining_creme'],
          exfoliating_cleanser: ['clear_marks_bar'],
          clarifying_gel: ['purifying_toner'],
          purifying_toner: ['clarifying_gel'],
          clear_marks_bar: ['exfoliating_cleanser'],
          sensitive_soap: ['exfoliating_cleanser'],
          revitalizing_serum: ['miracle_moisturizer'],
          miracle_moisturizer: ['revitalizing_serum']
        };
        const replacementReasons = {
          exfoliating_cleanser: 'Clear Marks Bar is the stronger cleanser. It helps clear active breakouts on the face or body and fade the marks they leave. Start once a day.',
          spot_treatment: 'This option still targets dark marks while your first choice is unavailable.',
          resurfacing_creme: 'This option still supports stubborn marks and uneven-looking tone while your first choice is unavailable.',
          refining_creme: 'This option keeps your tone-correcting step in place while your first choice is unavailable.',
          clarifying_gel: 'Purifying Toner keeps the oil-control and breakout-support step in your routine.',
          purifying_toner: 'Clarifying Gel keeps the leave-on breakout-support step in your routine.'
        };
        const replacementByUnavailable = {};
        importantUnavailable.forEach(([key, value]) => {
          const replacement = (replacementChains[key] || []).find((candidate) =>
            config.products[candidate]?.variant && config.products[candidate].available && !blocked.has(candidate)
          );
          if (!replacement) return;
          replacementByUnavailable[key] = replacement;
          score(replacement, Math.max(12, value + 2));
        });

        const cleanserKeys = ['exfoliating_cleanser', 'clear_marks_bar', 'sensitive_soap'];
        const ranked = Object.entries(scores)
          .filter(([key, value]) => value > 0 && !blocked.has(key) && config.products[key]?.variant && config.products[key].available)
          .sort((a, b) => b[1] - a[1]);
        let cleanser = ranked.find(([key]) => cleanserKeys.includes(key))?.[0];
        if (!cleanser) {
          cleanser = (sensitiveSwap || exclusions.includes('salicylic_acid')) ? 'sensitive_soap' : 'exfoliating_cleanser';
          if (!config.products[cleanser]?.available || blocked.has(cleanser)) cleanser = cleanserKeys.find((key) => config.products[key]?.available && !blocked.has(key));
        }
        const treatmentCandidates = ranked.map(([key]) => key).filter((key) => !cleanserKeys.includes(key));
        const selectedRetinoid = treatmentCandidates.find((key) => ['resurfacing_creme', 'spot_treatment'].includes(key));
        const compatibleTreatments = treatmentCandidates.filter((key) => {
          if (key === 'purifying_toner' && treatmentCandidates.includes('clarifying_gel')) return false;
          if (selectedRetinoid && key === 'purifying_toner') return false;
          if (selectedRetinoid && ['resurfacing_creme', 'spot_treatment'].includes(key) && key !== selectedRetinoid) return false;
          return true;
        });
        const keys = [cleanser, ...compatibleTreatments].filter(Boolean).filter((key, index, list) => list.indexOf(key) === index).slice(0, 3);
        while (keys.length < 2 && config.products.miracle_moisturizer?.available && !keys.includes('miracle_moisturizer')) keys.push('miracle_moisturizer');

        const displayOrder = ['exfoliating_cleanser', 'clear_marks_bar', 'sensitive_soap', 'purifying_toner', 'clarifying_gel', 'revitalizing_serum', 'spot_eraser', 'resurfacing_creme', 'spot_treatment', 'refining_creme', 'miracle_moisturizer'];
        keys.sort((a, b) => displayOrder.indexOf(a) - displayOrder.indexOf(b));
        const products = keys.map((key) => ({ key, ...config.products[key] }));
        const primaryKey = ranked.map(([key]) => key).find((key) => keys.includes(key) && !cleanserKeys.includes(key)) || keys[0];
        const waitlistKey = importantUnavailable[0]?.[0] || null;
        const replacementKey = waitlistKey ? replacementByUnavailable[waitlistKey] || null : null;
        const waitlist = waitlistKey ? {
          key: waitlistKey,
          ...config.products[waitlistKey],
          replacementReason: replacementReasons[waitlistKey] || 'This keeps the same job in your routine while your first choice is unavailable.',
          replacement: replacementKey ? { key: replacementKey, ...config.products[replacementKey] } : null
        } : null;
        const full = products.reduce((sum, product) => sum + product.price, 0);
        const discounted = Math.round(full * 75) / 100;
        let nextKey = ({ dark_spots: 'miracle_moisturizer', acne: 'miracle_moisturizer', combined: 'spot_eraser', tone: 'miracle_moisturizer', maintenance: 'revitalizing_serum' })[lane];
        if (keys.includes(nextKey)) nextKey = ({ dark_spots: 'refining_creme', acne: 'purifying_toner', combined: 'revitalizing_serum', tone: 'revitalizing_serum', maintenance: 'spot_eraser' })[lane];
        if (activeRemoved || (lane === 'acne' && exclusions.includes('citric_acid'))) nextKey = null;
        const cartUrl = config.cartUrl || '/cart';
        const names = { dark_spots: 'Your Dark Spot Routine', acne: 'Your Breakout Starter Routine', combined: 'Your Breakout + Dark Mark Routine', tone: 'Your Even Tone Routine', maintenance: 'Your Maintenance Routine' };
        const badges = { dark_spots: 'For dark spots', acne: 'For breakouts', combined: 'For breakouts + marks', tone: 'For even tone', maintenance: 'For maintenance' };
        const why = {
          dark_spots: 'A focused routine to cleanse, support recovery, and fade the look of dark marks without unnecessary steps.',
          acne: 'A focused pair to cleanse thoroughly and support active breakouts without adding unnecessary steps.',
          combined: 'A focused routine that supports active breakouts and the marks they leave behind without recommending two competing treatment paths.',
          tone: 'A balanced routine to cleanse, smooth, and support a more even-looking tone.',
          maintenance: 'A streamlined routine to maintain comfort, hydration, and an even-looking tone.'
        };
        const concernCovered = !hasMarks || keys.some((key) => ['spot_eraser', 'spot_treatment', 'resurfacing_creme', 'refining_creme'].includes(key));
        return { lane, concerns, scores, status: activeRemoved && !concernCovered ? 'ingredient_conflict' : activeRemoved ? 'safety_adjusted' : 'recommended', products, keys, primaryKey, waitlist, full, discounted, nextKey, cartUrl, name: names[lane], badge: badges[lane], why: why[lane], notes };
      }

      function regimenMarkup(result) {
        const directions = {
          exfoliating_cleanser: { am: [10, 'Cleanse for 30 to 60 seconds with lukewarm water, rinse, and pat dry.'], pm: [10, 'Cleanse for 30 to 60 seconds with lukewarm water, rinse, and pat dry.'] },
          sensitive_soap: { am: [10, 'Cleanse gently for 30 to 60 seconds, rinse well, and pat dry.'], pm: [10, 'Cleanse gently for 30 to 60 seconds, rinse well, and pat dry.'] },
          clear_marks_bar: { am: [10, 'Lather one cleanser only, massage for 1 to 2 minutes, rinse, and pat dry.'], pm: [10, 'Lather one cleanser only, massage for 1 to 2 minutes, rinse, and pat dry.'] },
          purifying_toner: { am: [20, 'After cleansing, sweep 2 pumps over skin with a cotton pad. Do not rinse.'], pm: [20, 'After cleansing, sweep 2 pumps over skin with a cotton pad. Do not rinse.'] },
          clarifying_gel: { am: [30, 'After cleansing or toner, apply 2 pumps and let dry for 1 to 2 minutes.'], pm: [30, 'After cleansing or toner, apply 2 pumps and let dry for 1 to 2 minutes.'] },
          revitalizing_serum: { pm: [40, 'Apply 2 to 3 pumps and allow it to absorb before your nighttime corrective.'] },
          spot_eraser: { am: [45, 'Dab 1 to 2 pumps directly onto marks and let it absorb before moisturizer or SPF.'], pm: [45, 'Dab 1 to 2 pumps directly onto marks and let it absorb before moisturizer.'] },
          resurfacing_creme: { pm: [50, 'Apply 5 pumps as a thin layer at night. Use for 14 nights, then take 3 Miracle Moisturizer recovery nights.'] },
          spot_treatment: { pm: [50, 'Apply 2 to 3 pumps only to stubborn marks at night. Never use during a Resurfacing Crème course.'] },
          refining_creme: { am: [50, 'Apply as directed in the morning, not at night. Refining Crème has no SPF rating. Use a separate broad-spectrum SPF 30+ sunscreen.'] },
          miracle_moisturizer: { am: [60, 'Apply 2 to 3 pumps after treatment. Follow with SPF if needed.'], pm: [60, 'Apply 2 to 3 pumps as the final moisturizing step, except during active peeling nights.'] }
        };
        const list = (period) => result.products
          .filter((product) => directions[product.key]?.[period])
          .filter((product) => !(period === 'pm' && product.key === 'clear_marks_bar' && result.waitlist?.replacement?.key === 'clear_marks_bar'))
          .sort((a, b) => directions[a.key][period][0] - directions[b.key][period][0])
          .map((product) => `<li><strong>${escapeHtml(product.name)}</strong><small>${escapeHtml(directions[product.key][period][1])}</small></li>`).join('');
        return `<div class="ptq__regimen"><div class="ptq__routine"><h4>MORNING USE</h4><ol>${list('am') || '<li>Keep your morning steps gentle.</li>'}</ol><p class="ptq__routine-note">Finish with broad-spectrum SPF 30+ every morning.</p></div><div class="ptq__routine"><h4>EVENING USE</h4><ol>${list('pm') || '<li>Keep your evening steps gentle.</li>'}</ol></div></div>`;
      }

      function serviceFor(answers) {
        const concerns = Array.isArray(answers.concerns) ? answers.concerns : [answers.primary_goal].filter(Boolean);
        if (answers.breakout_type === 'cystic') return { now: ['Cystic Acne Facial', 'An intensive 90-minute corrective session for cystic or severe acne.'], later: ['Acne follow-up', 'Reassess progress in 30 days before repeating or stepping down treatment.'] };
        if (concerns.includes('active_breakouts')) return { now: ['Acne Facial', 'Manual extraction, high-frequency therapy, a retinol mask, and blue-light LED for active breakouts.'], later: ['Monthly Maintenance Facial', 'Return in 30 to 60 days to keep congestion and new marks under control.'] };
        if (concerns.includes('dark_spots') && ['more_than_five', 'larger_areas'].includes(answers.dark_mark_pattern)) return { now: ['Restoration System', 'Begin the three-phase corrective protocol for widespread marks, acne scarring, and uneven tone.'], later: ['Restoration System next phase', 'Continue with the next professionally assessed phase in 30 days.'] };
        if (concerns.includes('dark_spots')) return { now: ['Micro Crystal Buff Treatment', 'Lift dull surface buildup and support texture and hyperpigmentation with no downtime.'], later: ['Monthly Maintenance Facial', 'Maintain the result with a follow-up in 30 to 60 days.'] };
        if (concerns.includes('uneven_tone')) return { now: ['Micro Crystal Buff Treatment', 'Resurface dullness and uneven tone for a brighter-looking finish.'], later: ['Monthly Maintenance Facial', 'Maintain clarity and even tone in 30 to 60 days.'] };
        if (concerns.includes('maintenance')) return { now: ['Monthly Maintenance Facial', 'A 45-minute upkeep facial to keep clear skin your default.'], later: ['Monthly Maintenance Facial', 'Reserve the next visit in 6 to 8 weeks.'] };
        return { now: ['New Client Skin Analysis', 'Start with a 20-minute professional assessment; the $30 fee is credited toward a service booked within 30 days.'], later: ['Your prescribed service', 'Your Skin Magician will choose the correct follow-up after assessing your skin.'] };
      }

      function imageMarkup(products) {
        return products.map((product) => product.image ? `<img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.name)}" width="500" height="500" loading="eager">` : '').join('');
      }

      function initializeGeneralReviews() {
        const widget = stage.querySelector('[data-ptq-general-reviews]');
        if (!widget) return;
        let attempts = 0;
        const initialize = () => {
          if (!widget.isConnected || widget.childElementCount > 0) return;
          if (window.okeWidgetApi && typeof window.okeWidgetApi.initWidget === 'function') {
            window.okeWidgetApi.initWidget(widget, true);
            return;
          }
          attempts += 1;
          if (attempts < 40) window.setTimeout(initialize, 250);
        };
        initialize();
      }

      function saveOnDevice(result, answers) {
        try {
          const key = `pt_skin_quiz_v1:${config.customerId || 'guest'}`;
          localStorage.setItem(key, JSON.stringify({ answers, lane: result.lane, result_url: window.location.href, saved_at: new Date().toISOString() }));
          return true;
        } catch (error) {
          return false;
        }
      }

      async function addRoutineToCart(result, trigger) {
        const buttons = [stage.querySelector('[data-ptq-add-routine]'), stickyLink].filter(Boolean);
        const originalLabels = buttons.map((button) => button.textContent);
        buttons.forEach((button) => {
          button.setAttribute('aria-disabled', 'true');
          button.textContent = 'Adding routine…';
        });
        try {
          const response = await fetch(config.cartAddUrl || '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: result.products.map((product) => ({ id: product.variant, quantity: 1 })) })
          });
          if (!response.ok) throw new Error('Unable to add routine');
          const cartPath = encodeURIComponent(config.cartUrl || '/cart');
          await window.PTDiscounts.go(config.cartUrl || '/cart');
        } catch (error) {
          buttons.forEach((button, index) => {
            button.removeAttribute('aria-disabled');
            button.textContent = originalLabels[index];
          });
          const status = stage.querySelector('[data-ptq-cart-status]');
          if (status) status.textContent = 'We could not add the routine. Please try again.';
          trigger?.focus();
        }
      }

      function renderResult(result, answers, lead) {
        root.classList.remove('ptq--lead');
        document.documentElement.classList.remove('ptq-focus-mode');
        root.querySelector('.ptq__intro').hidden = true;
        root.querySelector('.ptq__privacy').hidden = true;
        root.querySelector('.ptq__progress').hidden = true;
        const next = result.nextKey ? config.products[result.nextKey] : null;
        const nextCopy = { dark_spots: 'Protects the new skin and helps keep tone even.', acne: 'Fades the marks breakouts can leave behind.', combined: 'Supports the next phase after the starter routine settles.', tone: 'Supports texture once your tone is settled.', maintenance: 'Adds targeted support when you are ready for another step.' }[result.lane];
        const service = answers.country_code === 'BS' ? serviceFor(answers) : null;
        const deliveryCopy = lead.revisit
          ? 'This saved result was restored on this device.'
          : lead.email_consent || lead.sms_consent
          ? 'Your result is ready. We are securely saving it with your selected contact preferences.'
          : 'Your result is ready. We are securely saving it to your Perfec-Tone customer profile without subscribing you to marketing.';
        stage.innerHTML = `<div class="ptq__results">
          <div class="ptq__result-head"><p class="ptq__eyebrow">Your skin match</p><div class="ptq__question-title">Here is exactly where to start.</div><p class="ptq__question-copy">Based on your answers, this is the simplest routine that fits your goal.</p></div>
          <article class="ptq__result-card" data-ptq-match>
            <div class="ptq__product-visual">${imageMarkup(result.products)}</div>
            <div class="ptq__result-card-body"><span class="ptq__badge">${result.badge}</span><h3>${result.name}</h3><p class="ptq__result-copy">${result.why}</p><div class="ptq__product-list">${result.products.map((product, index) => `<a href="${escapeHtml(product.url)}" target="_blank" rel="noopener noreferrer" aria-label="View ${escapeHtml(product.name)} product details in a new tab">${index + 1}. ${escapeHtml(product.name)}${result.waitlist?.replacement?.key === product.key ? ' · Added for now' : ''} ↗</a>`).join('')}</div><div class="ptq__price"><strong>${money(result.discounted)}</strong><s>${money(result.full)}</s></div><a class="ptq__action ptq__action--green" data-ptq-add-routine href="${result.cartUrl}">Add these products to cart, 25% off</a><p class="ptq__micro" data-ptq-cart-status aria-live="polite">Check your products in the cart. NEWCUSTOMER25 applies automatically.</p></div>
          </article>
          ${result.waitlist ? `<section class="ptq__result-section ptq__result-section--warning"><p class="ptq__section-label">Out of stock</p>${result.waitlist.replacement ? `<h3>Use ${escapeHtml(result.waitlist.replacement.name)} for now.</h3><div class="ptq__waitlist">${result.waitlist.image ? `<img src="${escapeHtml(result.waitlist.image)}" alt="${escapeHtml(result.waitlist.name)}" width="144" height="164" loading="lazy">` : ''}<div><strong>We first recommended ${escapeHtml(result.waitlist.name)}.</strong><span>${escapeHtml(result.waitlist.name)} is out of stock, so we added ${escapeHtml(result.waitlist.replacement.name)} instead. ${escapeHtml(result.waitlist.replacementReason)} You can get ${escapeHtml(result.waitlist.name)} later.</span><a class="ptq__action" href="${escapeHtml(result.waitlist.url)}">Tell me when ${escapeHtml(result.waitlist.name)} is back →</a></div></div>` : `<h3>${escapeHtml(result.waitlist.name)} is out of stock.</h3><div class="ptq__waitlist">${result.waitlist.image ? `<img src="${escapeHtml(result.waitlist.image)}" alt="${escapeHtml(result.waitlist.name)}" width="144" height="164" loading="lazy">` : ''}<div><strong>Start with the available products for now.</strong><span>You can get ${escapeHtml(result.waitlist.name)} when it is back.</span><a class="ptq__action" href="${escapeHtml(result.waitlist.url)}">Tell me when it is back →</a></div></div>`}</section>` : ''}
          ${result.notes.length ? `<section class="ptq__result-section ptq__result-section--mint"><p class="ptq__section-label">Personalized adjustment</p>${result.notes.map((note) => `<p class="ptq__result-copy">${escapeHtml(note)}</p>`).join('')}</section>` : ''}
          <section class="ptq__result-section"><p class="ptq__section-label">How to use</p><h3>Use these products in this order.</h3>${regimenMarkup(result)}<div class="ptq__links"><a href="/pages/regimen">See more how-to steps →</a><a href="/pages/whats-normal">What is normal? →</a>${result.keys.includes('resurfacing_creme') ? '<a href="/pages/retinol-rules">Retinol Rules →</a>' : ''}</div></section>
          ${next ? `<section class="ptq__result-section"><p class="ptq__section-label">Your next 30 to 60 days</p><h3>Nothing else to buy today.</h3><div class="ptq__next">${next.image ? `<img src="${escapeHtml(next.image)}" alt="${escapeHtml(next.name)}" width="500" height="500" loading="lazy">` : ''}<div><strong>After your first cycle, consider ${escapeHtml(next.name)}</strong><span>${nextCopy}</span></div></div></section>` : ''}
          <section class="ptq__result-section ptq__reviews" data-ptq-reviews-target><p class="ptq__section-label">Verified customer reviews</p><h3>What Perfec-Tone customers are saying.</h3><p class="ptq__review-copy">Read verified feedback from customers across Perfec-Tone routines.</p><div class="ptq__review-carousel" data-ptq-general-reviews data-oke-carousel data-oke-header-text="Perfec-Tone customer reviews" data-oke-header-badge-url="/pages/reviews"></div></section>
          ${result.status === 'ingredient_conflict' ? `<section class="ptq__result-section ptq__result-section--warning"><p class="ptq__section-label">Ingredient conflict</p><h3>Let an expert finish this plan with you.</h3><p class="ptq__result-copy">One of your exclusions rules out our treatment step. Start with the products above and talk to us for a custom plan.</p><div class="ptq__controls"><a class="ptq__action" href="https://wa.me/12428287546">Chat with a Glow Agent on WhatsApp →</a></div></section>` : ''}
          ${service ? `<section class="ptq__result-section ptq__result-section--mint"><p class="ptq__section-label">Your Bahamas care plan</p><h3>Products and professional care, in sequence.</h3><div class="ptq__service-plan"><div class="ptq__service"><p class="ptq__section-label">Book first</p><strong>${escapeHtml(service.now[0])}</strong><span>${escapeHtml(service.now[1])}</span></div><div class="ptq__service"><p class="ptq__section-label">In 30 to 60 days</p><strong>${escapeHtml(service.later[0])}</strong><span>${escapeHtml(service.later[1])}</span></div></div><div class="ptq__controls"><a class="ptq__action" href="https://booking.perfec-tone.com">Book an appointment →</a></div></section>` : ''}
          <p class="ptq__delivery" data-ptq-delivery>${deliveryCopy}</p>
          <div class="ptq__result-actions"><a class="ptq__action ptq__action--quiet" href="${escapeHtml(config.customerId ? config.accountUrl : config.loginUrl)}">${config.customerId ? 'View my account' : 'Sign in to my account'}</a><button class="ptq__action ptq__action--quiet" type="button" data-ptq-retake>Retake quiz</button><button class="ptq__action ptq__action--quiet" type="button" data-ptq-print>Print</button></div>
          <p class="ptq__save-status" data-ptq-save-status aria-live="polite"></p>
        </div>`;
        sticky.hidden = false;
        stickyPrice.textContent = money(result.discounted);
        stickyLink.href = result.cartUrl;
        stickyLink.textContent = 'Add these products to cart, 25% off';
        const addButtons = [stage.querySelector('[data-ptq-add-routine]'), stickyLink].filter(Boolean);
        addButtons.forEach((button) => { button.onclick = (event) => {
          event.preventDefault();
          if (button.getAttribute('aria-disabled') === 'true') return;
          addRoutineToCart(result, button);
        }; });
        stage.querySelector('[data-ptq-retake]').addEventListener('click', retake);
        stage.querySelector('[data-ptq-print]').addEventListener('click', () => window.print());
        const match = stage.querySelector('[data-ptq-match]');
        if (resultObserver) resultObserver.disconnect();
        resultObserver = new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting), { threshold: .12 });
        resultObserver.observe(match);
        document.documentElement.style.removeProperty('overflow');
        document.body.style.removeProperty('overflow');
        document.body.classList.remove('pt-drawer-open');
        initializeGeneralReviews();
        scrollToQuizTop();
      }

      async function finish(form) {
        const lead = Object.fromEntries(new FormData(form).entries());
        lead.email_consent = form.elements.email_consent.checked;
        lead.sms_consent = form.elements.sms_consent.checked;
        const result = buildResult(state);
        const token = btoa(unescape(encodeURIComponent(JSON.stringify(state)))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
        const resultUrl = new URL(window.location.href);
        resultUrl.searchParams.set('r', token);
        window.history.replaceState({}, '', resultUrl);
        saveOnDevice(result, state);
        renderResult(result, state, lead);

        if (!config.webhookUrl) return;
        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), 4000);
        const payload = {
          quiz_version: 'perfec_tone_quiz_v3_frontend_v1',
          hp: lead.website || '',
          email: lead.email,
          phone: lead.phone || '',
          full_name: lead.full_name,
          email_consent: lead.email_consent,
          sms_consent: lead.sms_consent,
          marketing_source: 'skin_quiz_v1',
          answers: state,
          result: {
            lane: result.lane,
            concerns: result.concerns,
            concern_scores: result.scores,
            recommendation_status: result.status,
            match_name: result.name,
            cart_variant_ids: result.products.map((product) => product.variant),
            cart_url: result.cartUrl,
            price_full: result.full,
            price_after_code: result.discounted,
            next_phase_product: result.nextKey,
            notes: result.notes,
            result_url: resultUrl.toString()
          },
          completed_at: new Date().toISOString()
        };
        fetch(config.webhookUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload), signal: controller.signal })
          .then((response) => {
            if (!response.ok) throw new Error('Capture failed');
            const delivery = stage.querySelector('[data-ptq-delivery]');
            if (delivery) delivery.textContent = lead.email_consent || lead.sms_consent
              ? 'Saved. Your selected email and text preferences are active.'
              : 'Saved to your Perfec-Tone customer profile. You were not subscribed to marketing.';
          })
          .catch(() => {
            const delivery = stage.querySelector('[data-ptq-delivery]');
            if (delivery) delivery.textContent = 'Your result is still available here, but we could not save it to your customer profile. Please try again.';
          })
          .finally(() => window.clearTimeout(timeout));
      }

      function retake() {
        Object.keys(state).forEach((key) => { state[key] = ['concerns', 'avoid_ingredients'].includes(key) ? [] : null; });
        screenHistory = [];
        sticky.hidden = true;
        sticky.classList.remove('is-visible');
        root.querySelector('.ptq__intro').hidden = false;
        root.querySelector('.ptq__privacy').hidden = false;
        root.querySelector('.ptq__progress').hidden = false;
        document.documentElement.classList.add('ptq-focus-mode');
        const url = new URL(window.location.href);
        url.searchParams.delete('r');
        window.history.replaceState({}, '', url);
        renderQuestion('goal');
        document.documentElement.style.removeProperty('overflow');
        document.body.style.removeProperty('overflow');
        document.body.classList.remove('pt-drawer-open');
        scrollToQuizTop();
      }

      const token = new URL(window.location.href).searchParams.get('r');
      if (token) {
        try {
          const normalized = token.replace(/-/g, '+').replace(/_/g, '/');
          const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, '=');
          const decoded = JSON.parse(decodeURIComponent(escape(atob(padded))));
          Object.assign(state, decoded);
          renderResult(buildResult(state), state, { revisit: true });
        } catch (error) {
          renderQuestion('goal');
        }
      } else renderQuestion('goal');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skin-quiz-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-ptq-root]');
    roots.forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      document.documentElement.classList.add('ptq-focus-mode');

      const config = JSON.parse(root.querySelector('[data-ptq-config]').textContent);
      const panel = root.querySelector('.ptq__panel');
      const stage = root.querySelector('[data-ptq-stage]');
      const back = root.querySelector('[data-ptq-back]');
      const stepText = root.querySelector('[data-ptq-step]');
      const progress = root.querySelector('[data-ptq-progress]');
      const progressFill = progress.querySelector('span');
      const sticky = root.querySelector('[data-ptq-sticky]');
      const stickyPrice = root.querySelector('[data-ptq-sticky-price]');
      const stickyLink = root.querySelector('[data-ptq-sticky-link]');
      const scrollToQuizTop = (element = root) => {
        const headerClearance = window.innerWidth <= 620 ? 118 : 124;
        window.scrollTo({ top: Math.max(0, element.getBoundingClientRect().top + window.scrollY - headerClearance), behavior: 'auto' });
      };

      const state = {
        concerns: [],
        skin_type: null,
        breakout_type: null,
        dark_mark_pattern: null,
        sensitivity_level: null,
        avoid_ingredients: [],
        country_code: null,
        country_name: null
      };

      const details = {
        goal: {
          phase: 1,
          key: 'concerns',
          multi: true,
          max: 2,
          title: 'What would you like to focus on?',
          copy: 'Choose up to two. For breakouts and the marks they leave, choose both.',
          choices: [
            ['Fade dark spots or acne marks', 'dark_spots'],
            ['Clear active breakouts', 'active_breakouts'],
            ['Even out dull or uneven tone', 'uneven_tone'],
            ['I am just maintaining my skin', 'maintenance'],
            ['I am not sure yet', 'not_sure']
          ]
        },
        skin: {
          phase: 2,
          key: 'skin_type',
          title: 'How does your skin feel most days?',
          copy: 'Choose the closest fit. Not sure is fine.',
          choices: [['Oily', 'oily'], ['Dry', 'dry'], ['Combination', 'combination'], ['Normal', 'normal'], ['Sensitive or reactive', 'sensitive'], ['Not sure', 'not_sure']]
        },
        breakout: {
          phase: 3,
          key: 'breakout_type',
          title: 'What do your breakouts look and feel like?',
          copy: 'Choose deep and painful if the bumps sit beneath your skin.',
          choices: [['Mostly surface pimples or whiteheads', 'surface'], ['Deep, painful, cystic breakouts', 'cystic'], ['Occasional breakouts only', 'occasional'], ['I am not dealing with active breakouts right now', 'none']]
        },
        marks: {
          phase: 3,
          key: 'dark_mark_pattern',
          title: 'Are you treating a few marks or a wider area?',
          copy: 'This helps us choose targeted care or a broader routine.',
          choices: [['1 to 5 individual spots', 'one_to_five'], ['More than 5 spots', 'more_than_five'], ['Larger areas of uneven pigment', 'larger_areas'], ['I am not sure', 'not_sure']]
        },
        sensitivity: {
          phase: 4,
          key: 'sensitivity_level',
          title: 'How does your skin respond to something new?',
          copy: 'Think about stinging, burning or sensitivity.',
          choices: [['My skin usually adjusts well', 'low'], ['I can be a little sensitive', 'medium'], ['My skin stings, burns, or reacts easily', 'high'], ['I am not sure', 'not_sure']]
        },
        exclusions: {
          phase: 5,
          key: 'avoid_ingredients',
          multi: true,
          title: 'What should we check before choosing your products?',
          copy: 'Select every option that applies. We use this to check ingredient conflicts.',
          choices: [['I am pregnant or breastfeeding', 'pregnant_breastfeeding'], ['I use prescription tretinoin or another retinoid', 'prescription_retinoid'], ['Wheat germ oil allergy or sensitivity', 'wheat_germ_oil'], ['Citric acid allergy or sensitivity', 'citric_acid'], ['Salicylic acid allergy or sensitivity', 'salicylic_acid'], ['None of these', 'none'], ['I am not sure', 'not_sure']]
        },
        country: { phase: 6, title: 'Where are you located?', copy: 'Your location helps us show the right shopping or service option.' },
        lead: { phase: 7, title: 'Your routine is ready.', copy: 'See your match and 25% first-order offer. Emails and texts are optional.' }
      };

      const countryCodes = ['AD','AE','AF','AG','AI','AL','AM','AO','AQ','AR','AS','AT','AU','AW','AX','AZ','BA','BB','BD','BE','BF','BG','BH','BI','BJ','BL','BM','BN','BO','BQ','BR','BS','BT','BV','BW','BY','BZ','CA','CC','CD','CF','CG','CH','CI','CK','CL','CM','CN','CO','CR','CU','CV','CW','CX','CY','CZ','DE','DJ','DK','DM','DO','DZ','EC','EE','EG','EH','ER','ES','ET','FI','FJ','FK','FM','FO','FR','GA','GB','GD','GE','GF','GG','GH','GI','GL','GM','GN','GP','GQ','GR','GS','GT','GU','GW','GY','HK','HM','HN','HR','HT','HU','ID','IE','IL','IM','IN','IO','IQ','IR','IS','IT','JE','JM','JO','JP','KE','KG','KH','KI','KM','KN','KP','KR','KW','KY','KZ','LA','LB','LC','LI','LK','LR','LS','LT','LU','LV','LY','MA','MC','MD','ME','MF','MG','MH','MK','ML','MM','MN','MO','MP','MQ','MR','MS','MT','MU','MV','MW','MX','MY','MZ','NA','NC','NE','NF','NG','NI','NL','NO','NP','NR','NU','NZ','OM','PA','PE','PF','PG','PH','PK','PL','PM','PN','PR','PS','PT','PW','PY','QA','RE','RO','RS','RU','RW','SA','SB','SC','SD','SE','SG','SH','SI','SJ','SK','SL','SM','SN','SO','SR','SS','ST','SV','SX','SY','SZ','TC','TD','TF','TG','TH','TJ','TK','TL','TM','TN','TO','TR','TT','TV','TW','TZ','UA','UG','UM','US','UY','UZ','VA','VC','VE','VG','VI','VN','VU','WF','WS','YE','YT','ZA','ZM','ZW'];
      const countryNames = typeof Intl.DisplayNames === 'function' ? new Intl.DisplayNames([navigator.language || 'en'], { type: 'region' }) : null;
      const countries = countryCodes.map((code) => ({ code, name: countryNames ? countryNames.of(code) : code })).sort((a, b) => a.name.localeCompare(b.name));

      let current = 'goal';
      let screenHistory = [];
      let resultObserver;

      const escapeHtml = (value) => String(value || '').replace(/[&<>"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[character]));
      const money = (value) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);

      function positionCurrentStep() {
        if (!screenHistory.length) return;
        requestAnimationFrame(() => {
          scrollToQuizTop(panel);
        });
      }

      function sequenceAfter(screen) {
        if (screen === 'goal') return 'skin';
        if (screen === 'skin') {
          if (state.concerns.includes('active_breakouts')) return 'breakout';
          if (state.concerns.includes('dark_spots') || state.concerns.includes('not_sure')) return 'marks';
          return 'sensitivity';
        }
        if (screen === 'breakout') return state.concerns.includes('dark_spots') ? 'marks' : 'sensitivity';
        if (screen === 'marks') return 'sensitivity';
        if (screen === 'sensitivity') return 'exclusions';
        if (screen === 'exclusions') return 'country';
        if (screen === 'country') return 'lead';
        return null;
      }

      function setProgress() {
        const total = 6
          + (state.concerns.includes('active_breakouts') ? 1 : 0)
          + (state.concerns.includes('dark_spots') || state.concerns.includes('not_sure') ? 1 : 0);
        const position = Math.min(screenHistory.length + 1, total);
        stepText.textContent = `Step ${position} of ${total}`;
        progress.setAttribute('aria-valuemax', String(total));
        progress.setAttribute('aria-valuenow', String(position));
        progressFill.style.width = `${(position / total) * 100}%`;
        back.hidden = screenHistory.length === 0;
      }

      function renderQuestion(name) {
        root.classList.remove('ptq--lead');
        current = name;
        const question = details[name];
        setProgress(question.phase);
        const selected = question.multi ? state[question.key] : state[question.key];
        stage.innerHTML = `
          <fieldset class="ptq__question">
            <legend>
              <span class="ptq__question-title">${escapeHtml(question.title)}</span>
              <span class="ptq__question-copy">${escapeHtml(question.copy)}</span>
            </legend>
            <div class="ptq__choices">
              ${question.choices.map(([label, value]) => {
                const isSelected = question.multi ? selected.includes(value) : selected === value;
                return `<button class="ptq__choice${question.multi ? ' ptq__choice--multi' : ''}" type="button" data-value="${value}" aria-pressed="${isSelected}">${escapeHtml(label)}</button>`;
              }).join('')}
            </div>
            <p class="ptq__error" data-ptq-error hidden>Please choose an answer to continue.</p>
            <div class="ptq__controls"><button class="ptq__action" type="button" data-ptq-continue ${question.multi ? '' : selected ? '' : 'disabled'}>Continue →</button></div>
          </fieldset>`;

        const continueAction = stage.querySelector('[data-ptq-continue]');
        stage.querySelectorAll('[data-value]').forEach((choice) => {
          choice.addEventListener('click', () => {
            const value = choice.dataset.value;
            if (question.multi) {
              let values = [...state[question.key]];
              const exclusiveValues = question.key === 'concerns' ? ['maintenance', 'not_sure'] : ['none', 'not_sure'];
              if (exclusiveValues.includes(value)) values = values.includes(value) ? [] : [value];
              else {
                values = values.filter((item) => !exclusiveValues.includes(item));
                values = values.includes(value) ? values.filter((item) => item !== value) : [...values, value].slice(0, question.max || 99);
              }
              state[question.key] = values;
              stage.querySelectorAll('[data-value]').forEach((item) => item.setAttribute('aria-pressed', String(values.includes(item.dataset.value))));
              continueAction.disabled = values.length === 0;
            } else {
              state[question.key] = value;
              stage.querySelectorAll('[data-value]').forEach((item) => item.setAttribute('aria-pressed', String(item === choice)));
              continueAction.disabled = false;
            }
          });
        });
        continueAction.addEventListener('click', advance);
        stage.querySelector('[data-value]')?.focus({ preventScroll: true });
        positionCurrentStep();
      }

      function renderCountry() {
        root.classList.remove('ptq--lead');
        current = 'country';
        setProgress(6);
        stage.innerHTML = `
          <div class="ptq__question">
            <div class="ptq__question-title">${details.country.title}</div>
            <div class="ptq__question-copy">${details.country.copy}</div>
            <div class="ptq__field-grid">
              <div class="ptq__field-row">
                <label for="ptq-country-${root.dataset.sectionId}">Country or region</label>
                <input class="ptq__field" id="ptq-country-${root.dataset.sectionId}" list="ptq-countries-${root.dataset.sectionId}" autocomplete="country-name" value="${escapeHtml(state.country_name || '')}" placeholder="Start typing your country" data-ptq-country>
                <datalist id="ptq-countries-${root.dataset.sectionId}">${countries.map((country) => `<option value="${escapeHtml(country.name)}"></option>`).join('')}</datalist>
              </div>
            </div>
            <p class="ptq__error" data-ptq-error hidden>Please choose a country from the list.</p>
            <div class="ptq__controls"><button class="ptq__action" type="button" data-ptq-continue ${state.country_code ? '' : 'disabled'}>Continue →</button></div>
          </div>`;
        const input = stage.querySelector('[data-ptq-country]');
        const continueAction = stage.querySelector('[data-ptq-continue]');
        input.addEventListener('input', () => {
          const match = countries.find((country) => country.name.toLowerCase() === input.value.trim().toLowerCase());
          state.country_code = match ? match.code : null;
          state.country_name = match ? match.name : null;
          continueAction.disabled = !match;
        });
        continueAction.addEventListener('click', advance);
        input.focus({ preventScroll: true });
        positionCurrentStep();
      }

      function renderLead() {
        root.classList.add('ptq--lead');
        current = 'lead';
        setProgress(7);
        stage.innerHTML = `
          <form class="ptq__question" data-ptq-lead novalidate>
            <div class="ptq__question-title">${details.lead.title}</div>
            <div class="ptq__question-copy">${details.lead.copy}</div>
            <div class="ptq__field-grid">
              <div class="ptq__field-row"><label for="ptq-name-${root.dataset.sectionId}">Name</label><input class="ptq__field" id="ptq-name-${root.dataset.sectionId}" name="full_name" autocomplete="name" required></div>
              <div class="ptq__field-row"><label for="ptq-email-${root.dataset.sectionId}">Email</label><input class="ptq__field" id="ptq-email-${root.dataset.sectionId}" name="email" type="email" autocomplete="email" required></div>
              <div class="ptq__field-row"><label for="ptq-phone-${root.dataset.sectionId}">Phone <span class="ptq__hint">optional</span></label><input class="ptq__field" id="ptq-phone-${root.dataset.sectionId}" name="phone" type="tel" autocomplete="tel" inputmode="tel"></div>
              <input name="website" tabindex="-1" autocomplete="off" aria-hidden="true" hidden>
              <label class="ptq__check"><input type="checkbox" name="email_consent"><span class="ptq__check-box" aria-hidden="true"></span><span>Email me skincare guidance, product updates, and offers. Unsubscribe anytime.</span></label>
              <label class="ptq__check"><input type="checkbox" name="sms_consent"><span class="ptq__check-box" aria-hidden="true"></span><span>Send me recurring automated texts from Perfec-Tone with skincare tips and offers. Consent is not a condition of purchase. Frequency varies. Msg &amp; data rates may apply. Reply STOP to cancel or HELP for help.</span></label>
            </div>
            <p class="ptq__micro">25% off your first one-time order with NEWCUSTOMER25. Eligibility is confirmed at checkout.</p>
            <p class="ptq__error" data-ptq-error hidden>Please enter your name and a valid email address.</p>
            <div class="ptq__controls"><button class="ptq__action ptq__action--green" type="submit">Show my match →</button></div>
          </form>`;
        const form = stage.querySelector('[data-ptq-lead]');
        const phone = form.elements.phone;
        const smsConsent = form.elements.sms_consent;
        const syncSmsAvailability = () => {
          smsConsent.disabled = !phone.value.trim();
          if (smsConsent.disabled) smsConsent.checked = false;
        };
        phone.addEventListener('input', syncSmsAvailability);
        syncSmsAvailability();
        form.addEventListener('submit', (event) => {
          event.preventDefault();
          if (!form.elements.full_name.validity.valid || !form.elements.email.validity.valid) {
            stage.querySelector('[data-ptq-error]').hidden = false;
            (form.elements.full_name.validity.valid ? form.elements.email : form.elements.full_name).focus();
            return;
          }
          if (form.elements.sms_consent.checked && !form.elements.phone.value.trim()) {
            stage.querySelector('[data-ptq-error]').textContent = 'Enter a phone number to receive text messages.';
            stage.querySelector('[data-ptq-error]').hidden = false;
            form.elements.phone.focus();
            return;
          }
          finish(form);
        });
        positionCurrentStep();
      }

      function advance() {
        const next = sequenceAfter(current);
        if (!next) return;
        screenHistory.push(current);
        if (next === 'country') renderCountry();
        else if (next === 'lead') renderLead();
        else renderQuestion(next);
      }

      back.addEventListener('click', () => {
        const previous = screenHistory.pop();
        if (!previous) return;
        if (previous === 'country') renderCountry();
        else if (previous === 'lead') renderLead();
        else renderQuestion(previous);
      });

      function buildResult(answers) {
        const concerns = Array.isArray(answers.concerns) ? answers.concerns : [answers.primary_goal].filter(Boolean);
        const hasAcne = concerns.includes('active_breakouts') && answers.breakout_type !== 'none';
        const hasMarks = concerns.includes('dark_spots') || concerns.includes('not_sure');
        const lane = hasAcne && hasMarks ? 'combined' : hasAcne ? 'acne' : hasMarks ? 'dark_spots' : concerns.includes('maintenance') ? 'maintenance' : 'tone';
        const exclusions = answers.avoid_ingredients || [];
        const avoidRetinoids = exclusions.includes('pregnant_breastfeeding') || exclusions.includes('prescription_retinoid');
        const notes = [];
        const sensitiveSwap = answers.skin_type === 'sensitive' || answers.sensitivity_level === 'high' || exclusions.includes('salicylic_acid');
        const scores = Object.fromEntries(Object.keys(config.products).map((key) => [key, 0]));
        const score = (key, amount) => { scores[key] = (scores[key] || 0) + amount; };

        if (hasAcne && answers.breakout_type === 'cystic' && !sensitiveSwap) score('clear_marks_bar', 9);
        else if (sensitiveSwap || ['dry', 'normal'].includes(answers.skin_type) || concerns.includes('maintenance')) score('sensitive_soap', 7);
        else score('exfoliating_cleanser', 7);

        if (hasAcne) {
          score('clarifying_gel', 10);
          if (answers.breakout_type !== 'occasional') score('purifying_toner', 5);
          score('exfoliating_cleanser', 3);
        }
        if (hasMarks) {
          if (answers.dark_mark_pattern === 'one_to_five') score(sensitiveSwap ? 'spot_eraser' : 'spot_treatment', 10);
          else score(sensitiveSwap ? 'spot_eraser' : 'resurfacing_creme', 10);
          score('revitalizing_serum', 3);
        }
        if (concerns.includes('uneven_tone')) {
          score(sensitiveSwap ? 'spot_eraser' : 'refining_creme', 9);
          score('revitalizing_serum', 6);
        }
        if (concerns.includes('maintenance')) {
          score('miracle_moisturizer', 9);
          score('revitalizing_serum', 6);
        }
        if (concerns.includes('not_sure')) {
          score('spot_eraser', 7);
          score('miracle_moisturizer', 5);
        }

        if (sensitiveSwap) notes.push('Best for sensitive skin: we selected the gentler route and recommend introducing one product at a time.');
        const blocked = new Set();
        if (exclusions.includes('wheat_germ_oil')) blocked.add('clarifying_gel');
        if (exclusions.includes('citric_acid')) ['resurfacing_creme', 'refining_creme'].forEach((key) => blocked.add(key));
        if (exclusions.includes('salicylic_acid')) ['exfoliating_cleanser', 'clear_marks_bar'].forEach((key) => blocked.add(key));
        if (avoidRetinoids) ['resurfacing_creme', 'refining_creme', 'spot_treatment'].forEach((key) => blocked.add(key));
        if (sensitiveSwap) blocked.add('spot_treatment');
        if (hasMarks && (avoidRetinoids || exclusions.includes('citric_acid'))) score('spot_eraser', 12);
        const activeRemoved = (exclusions.includes('wheat_germ_oil') && scores.clarifying_gel >= 9)
          || (exclusions.includes('citric_acid') && ['resurfacing_creme', 'refining_creme'].some((key) => scores[key] >= 9))
          || (exclusions.includes('salicylic_acid') && ['exfoliating_cleanser', 'clear_marks_bar'].some((key) => scores[key] >= 9))
          || (avoidRetinoids && ['resurfacing_creme', 'refining_creme', 'spot_treatment'].some((key) => scores[key] >= 9));
        if (avoidRetinoids) notes.push('We removed Perfec-Tone retinoid products from this routine based on your safety answer.');
      if (exclusions.includes('prescription_retinoid')) notes.push("Using prescription tretinoin? Discuss your skin goals and the Perfec-Tone products you're considering with your prescribing clinician before starting them. We don't recommend pairing our treatment actives with tretinoin or planning alternate nights. Please don't stop or change your prescription to start our products.");
        if (lane === 'combined') {
          const clarifyingIsUsable = !blocked.has('clarifying_gel') && config.products.clarifying_gel?.available;
          if (clarifyingIsUsable) {
            score('clarifying_gel', 16);
            blocked.add('purifying_toner');
          } else {
            score('purifying_toner', 16);
          }
          let markTreatment = 'spot_eraser';
          if (!sensitiveSwap && !avoidRetinoids && answers.dark_mark_pattern === 'one_to_five' && !blocked.has('spot_treatment')) markTreatment = 'spot_treatment';
          else if (!sensitiveSwap && !avoidRetinoids && answers.dark_mark_pattern !== 'one_to_five' && !blocked.has('resurfacing_creme')) markTreatment = 'resurfacing_creme';
          score(markTreatment, 15);
          notes.push('Your three-product plan reserves one step for cleansing, one for active breakouts, and one for dark marks. Purifying Toner and Clarifying Gel are not paired in this streamlined routine.');
        }
        if (exclusions.includes('not_sure')) notes.push('Please review each linked ingredient list before beginning your routine.');
        const importantUnavailable = Object.entries(scores)
          .filter(([key, value]) => value >= 9 && !blocked.has(key) && config.products[key]?.variant && !config.products[key].available)
          .sort((a, b) => b[1] - a[1]);
        const replacementChains = {
          spot_treatment: ['resurfacing_creme', 'refining_creme', 'spot_eraser'],
          resurfacing_creme: ['refining_creme', 'spot_eraser'],
          refining_creme: ['spot_eraser'],
          spot_eraser: ['refining_creme'],
          exfoliating_cleanser: ['clear_marks_bar'],
          clarifying_gel: ['purifying_toner'],
          purifying_toner: ['clarifying_gel'],
          clear_marks_bar: ['exfoliating_cleanser'],
          sensitive_soap: ['exfoliating_cleanser'],
          revitalizing_serum: ['miracle_moisturizer'],
          miracle_moisturizer: ['revitalizing_serum']
        };
        const replacementReasons = {
          exfoliating_cleanser: 'Clear Marks Bar is the stronger cleanser. It helps clear active breakouts on the face or body and fade the marks they leave. Start once a day.',
          spot_treatment: 'This option still targets dark marks while your first choice is unavailable.',
          resurfacing_creme: 'This option still supports stubborn marks and uneven-looking tone while your first choice is unavailable.',
          refining_creme: 'This option keeps your tone-correcting step in place while your first choice is unavailable.',
          clarifying_gel: 'Purifying Toner keeps the oil-control and breakout-support step in your routine.',
          purifying_toner: 'Clarifying Gel keeps the leave-on breakout-support step in your routine.'
        };
        const replacementByUnavailable = {};
        importantUnavailable.forEach(([key, value]) => {
          const replacement = (replacementChains[key] || []).find((candidate) =>
            config.products[candidate]?.variant && config.products[candidate].available && !blocked.has(candidate)
          );
          if (!replacement) return;
          replacementByUnavailable[key] = replacement;
          score(replacement, Math.max(12, value + 2));
        });

        const cleanserKeys = ['exfoliating_cleanser', 'clear_marks_bar', 'sensitive_soap'];
        const ranked = Object.entries(scores)
          .filter(([key, value]) => value > 0 && !blocked.has(key) && config.products[key]?.variant && config.products[key].available)
          .sort((a, b) => b[1] - a[1]);
        let cleanser = ranked.find(([key]) => cleanserKeys.includes(key))?.[0];
        if (!cleanser) {
          cleanser = (sensitiveSwap || exclusions.includes('salicylic_acid')) ? 'sensitive_soap' : 'exfoliating_cleanser';
          if (!config.products[cleanser]?.available || blocked.has(cleanser)) cleanser = cleanserKeys.find((key) => config.products[key]?.available && !blocked.has(key));
        }
        const treatmentCandidates = ranked.map(([key]) => key).filter((key) => !cleanserKeys.includes(key));
        const selectedRetinoid = treatmentCandidates.find((key) => ['resurfacing_creme', 'spot_treatment'].includes(key));
        const compatibleTreatments = treatmentCandidates.filter((key) => {
          if (key === 'purifying_toner' && treatmentCandidates.includes('clarifying_gel')) return false;
          if (selectedRetinoid && key === 'purifying_toner') return false;
          if (selectedRetinoid && ['resurfacing_creme', 'spot_treatment'].includes(key) && key !== selectedRetinoid) return false;
          return true;
        });
        const keys = [cleanser, ...compatibleTreatments].filter(Boolean).filter((key, index, list) => list.indexOf(key) === index).slice(0, 3);
        while (keys.length < 2 && config.products.miracle_moisturizer?.available && !keys.includes('miracle_moisturizer')) keys.push('miracle_moisturizer');

        const displayOrder = ['exfoliating_cleanser', 'clear_marks_bar', 'sensitive_soap', 'purifying_toner', 'clarifying_gel', 'revitalizing_serum', 'spot_eraser', 'resurfacing_creme', 'spot_treatment', 'refining_creme', 'miracle_moisturizer'];
        keys.sort((a, b) => displayOrder.indexOf(a) - displayOrder.indexOf(b));
        const products = keys.map((key) => ({ key, ...config.products[key] }));
        const primaryKey = ranked.map(([key]) => key).find((key) => keys.includes(key) && !cleanserKeys.includes(key)) || keys[0];
        const waitlistKey = importantUnavailable[0]?.[0] || null;
        const replacementKey = waitlistKey ? replacementByUnavailable[waitlistKey] || null : null;
        const waitlist = waitlistKey ? {
          key: waitlistKey,
          ...config.products[waitlistKey],
          replacementReason: replacementReasons[waitlistKey] || 'This keeps the same job in your routine while your first choice is unavailable.',
          replacement: replacementKey ? { key: replacementKey, ...config.products[replacementKey] } : null
        } : null;
        const full = products.reduce((sum, product) => sum + product.price, 0);
        const discounted = Math.round(full * 75) / 100;
        let nextKey = ({ dark_spots: 'miracle_moisturizer', acne: 'miracle_moisturizer', combined: 'spot_eraser', tone: 'miracle_moisturizer', maintenance: 'revitalizing_serum' })[lane];
        if (keys.includes(nextKey)) nextKey = ({ dark_spots: 'refining_creme', acne: 'purifying_toner', combined: 'revitalizing_serum', tone: 'revitalizing_serum', maintenance: 'spot_eraser' })[lane];
        if (activeRemoved || (lane === 'acne' && exclusions.includes('citric_acid'))) nextKey = null;
        const cartUrl = config.cartUrl || '/cart';
        const names = { dark_spots: 'Your Dark Spot Routine', acne: 'Your Breakout Starter Routine', combined: 'Your Breakout + Dark Mark Routine', tone: 'Your Even Tone Routine', maintenance: 'Your Maintenance Routine' };
        const badges = { dark_spots: 'For dark spots', acne: 'For breakouts', combined: 'For breakouts + marks', tone: 'For even tone', maintenance: 'For maintenance' };
        const why = {
          dark_spots: 'A focused routine to cleanse, support recovery, and fade the look of dark marks without unnecessary steps.',
          acne: 'A focused pair to cleanse thoroughly and support active breakouts without adding unnecessary steps.',
          combined: 'A focused routine that supports active breakouts and the marks they leave behind without recommending two competing treatment paths.',
          tone: 'A balanced routine to cleanse, smooth, and support a more even-looking tone.',
          maintenance: 'A streamlined routine to maintain comfort, hydration, and an even-looking tone.'
        };
        const concernCovered = !hasMarks || keys.some((key) => ['spot_eraser', 'spot_treatment', 'resurfacing_creme', 'refining_creme'].includes(key));
        return { lane, concerns, scores, status: activeRemoved && !concernCovered ? 'ingredient_conflict' : activeRemoved ? 'safety_adjusted' : 'recommended', products, keys, primaryKey, waitlist, full, discounted, nextKey, cartUrl, name: names[lane], badge: badges[lane], why: why[lane], notes };
      }

      function regimenMarkup(result) {
        const directions = {
          exfoliating_cleanser: { am: [10, 'Cleanse for 30 to 60 seconds with lukewarm water, rinse, and pat dry.'], pm: [10, 'Cleanse for 30 to 60 seconds with lukewarm water, rinse, and pat dry.'] },
          sensitive_soap: { am: [10, 'Cleanse gently for 30 to 60 seconds, rinse well, and pat dry.'], pm: [10, 'Cleanse gently for 30 to 60 seconds, rinse well, and pat dry.'] },
          clear_marks_bar: { am: [10, 'Lather one cleanser only, massage for 1 to 2 minutes, rinse, and pat dry.'], pm: [10, 'Lather one cleanser only, massage for 1 to 2 minutes, rinse, and pat dry.'] },
          purifying_toner: { am: [20, 'After cleansing, sweep 2 pumps over skin with a cotton pad. Do not rinse.'], pm: [20, 'After cleansing, sweep 2 pumps over skin with a cotton pad. Do not rinse.'] },
          clarifying_gel: { am: [30, 'After cleansing or toner, apply 2 pumps and let dry for 1 to 2 minutes.'], pm: [30, 'After cleansing or toner, apply 2 pumps and let dry for 1 to 2 minutes.'] },
          revitalizing_serum: { pm: [40, 'Apply 2 to 3 pumps and allow it to absorb before your nighttime corrective.'] },
          spot_eraser: { am: [45, 'Dab 1 to 2 pumps directly onto marks and let it absorb before moisturizer or SPF.'], pm: [45, 'Dab 1 to 2 pumps directly onto marks and let it absorb before moisturizer.'] },
          resurfacing_creme: { pm: [50, 'Apply 5 pumps as a thin layer at night. Use for 14 nights, then take 3 Miracle Moisturizer recovery nights.'] },
          spot_treatment: { pm: [50, 'Apply 2 to 3 pumps only to stubborn marks at night. Never use during a Resurfacing Crème course.'] },
          refining_creme: { am: [50, 'Apply as directed in the morning, not at night. Refining Crème has no SPF rating. Use a separate broad-spectrum SPF 30+ sunscreen.'] },
          miracle_moisturizer: { am: [60, 'Apply 2 to 3 pumps after treatment. Follow with SPF if needed.'], pm: [60, 'Apply 2 to 3 pumps as the final moisturizing step, except during active peeling nights.'] }
        };
        const list = (period) => result.products
          .filter((product) => directions[product.key]?.[period])
          .filter((product) => !(period === 'pm' && product.key === 'clear_marks_bar' && result.waitlist?.replacement?.key === 'clear_marks_bar'))
          .sort((a, b) => directions[a.key][period][0] - directions[b.key][period][0])
          .map((product) => `<li><strong>${escapeHtml(product.name)}</strong><small>${escapeHtml(directions[product.key][period][1])}</small></li>`).join('');
        return `<div class="ptq__regimen"><div class="ptq__routine"><h4>MORNING USE</h4><ol>${list('am') || '<li>Keep your morning steps gentle.</li>'}</ol><p class="ptq__routine-note">Finish with broad-spectrum SPF 30+ every morning.</p></div><div class="ptq__routine"><h4>EVENING USE</h4><ol>${list('pm') || '<li>Keep your evening steps gentle.</li>'}</ol></div></div>`;
      }

      function serviceFor(answers) {
        const concerns = Array.isArray(answers.concerns) ? answers.concerns : [answers.primary_goal].filter(Boolean);
        if (answers.breakout_type === 'cystic') return { now: ['Cystic Acne Facial', 'An intensive 90-minute corrective session for cystic or severe acne.'], later: ['Acne follow-up', 'Reassess progress in 30 days before repeating or stepping down treatment.'] };
        if (concerns.includes('active_breakouts')) return { now: ['Acne Facial', 'Manual extraction, high-frequency therapy, a retinol mask, and blue-light LED for active breakouts.'], later: ['Monthly Maintenance Facial', 'Return in 30 to 60 days to keep congestion and new marks under control.'] };
        if (concerns.includes('dark_spots') && ['more_than_five', 'larger_areas'].includes(answers.dark_mark_pattern)) return { now: ['Restoration System', 'Begin the three-phase corrective protocol for widespread marks, acne scarring, and uneven tone.'], later: ['Restoration System next phase', 'Continue with the next professionally assessed phase in 30 days.'] };
        if (concerns.includes('dark_spots')) return { now: ['Micro Crystal Buff Treatment', 'Lift dull surface buildup and support texture and hyperpigmentation with no downtime.'], later: ['Monthly Maintenance Facial', 'Maintain the result with a follow-up in 30 to 60 days.'] };
        if (concerns.includes('uneven_tone')) return { now: ['Micro Crystal Buff Treatment', 'Resurface dullness and uneven tone for a brighter-looking finish.'], later: ['Monthly Maintenance Facial', 'Maintain clarity and even tone in 30 to 60 days.'] };
        if (concerns.includes('maintenance')) return { now: ['Monthly Maintenance Facial', 'A 45-minute upkeep facial to keep clear skin your default.'], later: ['Monthly Maintenance Facial', 'Reserve the next visit in 6 to 8 weeks.'] };
        return { now: ['New Client Skin Analysis', 'Start with a 20-minute professional assessment; the $30 fee is credited toward a service booked within 30 days.'], later: ['Your prescribed service', 'Your Skin Magician will choose the correct follow-up after assessing your skin.'] };
      }

      function imageMarkup(products) {
        return products.map((product) => product.image ? `<img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.name)}" width="500" height="500" loading="eager">` : '').join('');
      }

      function initializeGeneralReviews() {
        const widget = stage.querySelector('[data-ptq-general-reviews]');
        if (!widget) return;
        let attempts = 0;
        const initialize = () => {
          if (!widget.isConnected || widget.childElementCount > 0) return;
          if (window.okeWidgetApi && typeof window.okeWidgetApi.initWidget === 'function') {
            window.okeWidgetApi.initWidget(widget, true);
            return;
          }
          attempts += 1;
          if (attempts < 40) window.setTimeout(initialize, 250);
        };
        initialize();
      }

      function saveOnDevice(result, answers) {
        try {
          const key = `pt_skin_quiz_v1:${config.customerId || 'guest'}`;
          localStorage.setItem(key, JSON.stringify({ answers, lane: result.lane, result_url: window.location.href, saved_at: new Date().toISOString() }));
          return true;
        } catch (error) {
          return false;
        }
      }

      async function addRoutineToCart(result, trigger) {
        const buttons = [stage.querySelector('[data-ptq-add-routine]'), stickyLink].filter(Boolean);
        const originalLabels = buttons.map((button) => button.textContent);
        buttons.forEach((button) => {
          button.setAttribute('aria-disabled', 'true');
          button.textContent = 'Adding routine…';
        });
        try {
          const response = await fetch(config.cartAddUrl || '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: result.products.map((product) => ({ id: product.variant, quantity: 1 })) })
          });
          if (!response.ok) throw new Error('Unable to add routine');
          const cartPath = encodeURIComponent(config.cartUrl || '/cart');
          await window.PTDiscounts.go(config.cartUrl || '/cart');
        } catch (error) {
          buttons.forEach((button, index) => {
            button.removeAttribute('aria-disabled');
            button.textContent = originalLabels[index];
          });
          const status = stage.querySelector('[data-ptq-cart-status]');
          if (status) status.textContent = 'We could not add the routine. Please try again.';
          trigger?.focus();
        }
      }

      function renderResult(result, answers, lead) {
        root.classList.remove('ptq--lead');
        document.documentElement.classList.remove('ptq-focus-mode');
        root.querySelector('.ptq__intro').hidden = true;
        root.querySelector('.ptq__privacy').hidden = true;
        root.querySelector('.ptq__progress').hidden = true;
        const next = result.nextKey ? config.products[result.nextKey] : null;
        const nextCopy = { dark_spots: 'Protects the new skin and helps keep tone even.', acne: 'Fades the marks breakouts can leave behind.', combined: 'Supports the next phase after the starter routine settles.', tone: 'Supports texture once your tone is settled.', maintenance: 'Adds targeted support when you are ready for another step.' }[result.lane];
        const service = answers.country_code === 'BS' ? serviceFor(answers) : null;
        const deliveryCopy = lead.revisit
          ? 'This saved result was restored on this device.'
          : lead.email_consent || lead.sms_consent
          ? 'Your result is ready. We are securely saving it with your selected contact preferences.'
          : 'Your result is ready. We are securely saving it to your Perfec-Tone customer profile without subscribing you to marketing.';
        stage.innerHTML = `<div class="ptq__results">
          <div class="ptq__result-head"><p class="ptq__eyebrow">Your skin match</p><div class="ptq__question-title">Here is exactly where to start.</div><p class="ptq__question-copy">Based on your answers, this is the simplest routine that fits your goal.</p></div>
          <article class="ptq__result-card" data-ptq-match>
            <div class="ptq__product-visual">${imageMarkup(result.products)}</div>
            <div class="ptq__result-card-body"><span class="ptq__badge">${result.badge}</span><h3>${result.name}</h3><p class="ptq__result-copy">${result.why}</p><div class="ptq__product-list">${result.products.map((product, index) => `<a href="${escapeHtml(product.url)}" target="_blank" rel="noopener noreferrer" aria-label="View ${escapeHtml(product.name)} product details in a new tab">${index + 1}. ${escapeHtml(product.name)}${result.waitlist?.replacement?.key === product.key ? ' · Added for now' : ''} ↗</a>`).join('')}</div><div class="ptq__price"><strong>${money(result.discounted)}</strong><s>${money(result.full)}</s></div><a class="ptq__action ptq__action--green" data-ptq-add-routine href="${result.cartUrl}">Add these products to cart, 25% off</a><p class="ptq__micro" data-ptq-cart-status aria-live="polite">First-order price with NEWCUSTOMER25. One-time purchases only; eligibility is confirmed at checkout.</p></div>
          </article>
          ${result.waitlist ? `<section class="ptq__result-section ptq__result-section--warning"><p class="ptq__section-label">Out of stock</p>${result.waitlist.replacement ? `<h3>Use ${escapeHtml(result.waitlist.replacement.name)} for now.</h3><div class="ptq__waitlist">${result.waitlist.image ? `<img src="${escapeHtml(result.waitlist.image)}" alt="${escapeHtml(result.waitlist.name)}" width="144" height="164" loading="lazy">` : ''}<div><strong>We first recommended ${escapeHtml(result.waitlist.name)}.</strong><span>${escapeHtml(result.waitlist.name)} is out of stock, so we added ${escapeHtml(result.waitlist.replacement.name)} instead. ${escapeHtml(result.waitlist.replacementReason)} You can get ${escapeHtml(result.waitlist.name)} later.</span><a class="ptq__action" href="${escapeHtml(result.waitlist.url)}">Tell me when ${escapeHtml(result.waitlist.name)} is back →</a></div></div>` : `<h3>${escapeHtml(result.waitlist.name)} is out of stock.</h3><div class="ptq__waitlist">${result.waitlist.image ? `<img src="${escapeHtml(result.waitlist.image)}" alt="${escapeHtml(result.waitlist.name)}" width="144" height="164" loading="lazy">` : ''}<div><strong>Start with the available products for now.</strong><span>You can get ${escapeHtml(result.waitlist.name)} when it is back.</span><a class="ptq__action" href="${escapeHtml(result.waitlist.url)}">Tell me when it is back →</a></div></div>`}</section>` : ''}
          ${result.notes.length ? `<section class="ptq__result-section ptq__result-section--mint"><p class="ptq__section-label">Personalized adjustment</p>${result.notes.map((note) => `<p class="ptq__result-copy">${escapeHtml(note)}</p>`).join('')}</section>` : ''}
          <section class="ptq__result-section"><p class="ptq__section-label">How to use</p><h3>Use these products in this order.</h3>${regimenMarkup(result)}<div class="ptq__links"><a href="/pages/regimen">See more how-to steps →</a><a href="/pages/whats-normal">What is normal? →</a>${result.keys.includes('resurfacing_creme') ? '<a href="/pages/retinol-rules">Retinol Rules →</a>' : ''}</div></section>
          ${next ? `<section class="ptq__result-section"><p class="ptq__section-label">Your next 30 to 60 days</p><h3>Nothing else to buy today.</h3><div class="ptq__next">${next.image ? `<img src="${escapeHtml(next.image)}" alt="${escapeHtml(next.name)}" width="500" height="500" loading="lazy">` : ''}<div><strong>After your first cycle, consider ${escapeHtml(next.name)}</strong><span>${nextCopy}</span></div></div></section>` : ''}
          <section class="ptq__result-section ptq__reviews" data-ptq-reviews-target><p class="ptq__section-label">Verified customer reviews</p><h3>What Perfec-Tone customers are saying.</h3><p class="ptq__review-copy">Read verified feedback from customers across Perfec-Tone routines.</p><div class="ptq__review-carousel" data-ptq-general-reviews data-oke-carousel data-oke-header-text="Perfec-Tone customer reviews" data-oke-header-badge-url="/pages/reviews"></div></section>
          ${result.status === 'ingredient_conflict' ? `<section class="ptq__result-section ptq__result-section--warning"><p class="ptq__section-label">Ingredient conflict</p><h3>Let an expert finish this plan with you.</h3><p class="ptq__result-copy">One of your exclusions rules out our treatment step. Start with the products above and talk to us for a custom plan.</p><div class="ptq__controls"><a class="ptq__action" href="https://wa.me/12428287546">Chat with a Glow Agent on WhatsApp →</a></div></section>` : ''}
          ${service ? `<section class="ptq__result-section ptq__result-section--mint"><p class="ptq__section-label">Your Bahamas care plan</p><h3>Products and professional care, in sequence.</h3><div class="ptq__service-plan"><div class="ptq__service"><p class="ptq__section-label">Book first</p><strong>${escapeHtml(service.now[0])}</strong><span>${escapeHtml(service.now[1])}</span></div><div class="ptq__service"><p class="ptq__section-label">In 30 to 60 days</p><strong>${escapeHtml(service.later[0])}</strong><span>${escapeHtml(service.later[1])}</span></div></div><div class="ptq__controls"><a class="ptq__action" href="https://booking.perfec-tone.com">Book an appointment →</a></div></section>` : ''}
          <p class="ptq__delivery" data-ptq-delivery>${deliveryCopy}</p>
          <div class="ptq__result-actions"><a class="ptq__action ptq__action--quiet" href="${escapeHtml(config.customerId ? config.accountUrl : config.loginUrl)}">${config.customerId ? 'View my account' : 'Sign in to my account'}</a><button class="ptq__action ptq__action--quiet" type="button" data-ptq-retake>Retake quiz</button><button class="ptq__action ptq__action--quiet" type="button" data-ptq-print>Print</button></div>
          <p class="ptq__save-status" data-ptq-save-status aria-live="polite"></p>
        </div>`;
        sticky.hidden = false;
        stickyPrice.textContent = money(result.discounted);
        stickyLink.href = result.cartUrl;
        stickyLink.textContent = 'Add these products to cart, 25% off';
        const addButtons = [stage.querySelector('[data-ptq-add-routine]'), stickyLink].filter(Boolean);
        addButtons.forEach((button) => { button.onclick = (event) => {
          event.preventDefault();
          if (button.getAttribute('aria-disabled') === 'true') return;
          addRoutineToCart(result, button);
        }; });
        stage.querySelector('[data-ptq-retake]').addEventListener('click', retake);
        stage.querySelector('[data-ptq-print]').addEventListener('click', () => window.print());
        const match = stage.querySelector('[data-ptq-match]');
        if (resultObserver) resultObserver.disconnect();
        resultObserver = new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting), { threshold: .12 });
        resultObserver.observe(match);
        document.documentElement.style.removeProperty('overflow');
        document.body.style.removeProperty('overflow');
        document.body.classList.remove('pt-drawer-open');
        initializeGeneralReviews();
        scrollToQuizTop();
      }

      async function finish(form) {
        const lead = Object.fromEntries(new FormData(form).entries());
        lead.email_consent = form.elements.email_consent.checked;
        lead.sms_consent = form.elements.sms_consent.checked;
        const result = buildResult(state);
        const token = btoa(unescape(encodeURIComponent(JSON.stringify(state)))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
        const resultUrl = new URL(window.location.href);
        resultUrl.searchParams.set('r', token);
        window.history.replaceState({}, '', resultUrl);
        saveOnDevice(result, state);
        renderResult(result, state, lead);

        if (!config.webhookUrl) {
          const delivery = stage.querySelector('[data-ptq-delivery]');
          if (delivery) delivery.textContent = 'Your routine is available here. Signup is unavailable right now.';
          return;
        }
        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), 15000);
        const payload = {
          quiz_version: 'perfec_tone_quiz_v2',
          hp: lead.website || '',
          email: lead.email,
          phone: lead.phone || '',
          full_name: lead.full_name,
          email_consent: lead.email_consent,
          sms_consent: lead.sms_consent,
          marketing_source: 'skin_quiz_v2',
          answers: state,
          result: {
            lane: result.lane,
            concerns: result.concerns,
            concern_scores: result.scores,
            recommendation_status: result.status,
            match_name: result.name,
            cart_variant_ids: result.products.map((product) => product.variant),
            cart_url: result.cartUrl,
            price_full: result.full,
            price_after_code: result.discounted,
            next_phase_product: result.nextKey,
            notes: result.notes,
            result_url: resultUrl.toString()
          },
          completed_at: new Date().toISOString()
        };
        fetch(config.webhookUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload), signal: controller.signal })
          .then(async (response) => {
            if (!response.ok) throw new Error('Capture failed');
            const saved = await response.json();
            if (!saved.ok || !saved.customer_saved) throw new Error('Capture not confirmed');
            const delivery = stage.querySelector('[data-ptq-delivery]');
            if (delivery) delivery.textContent = lead.email_consent || lead.sms_consent
              ? saved.redo_synced
                ? 'Your routine and signup preferences are saved.'
                : 'Your routine is saved. We could not confirm your email or text signup yet.'
              : 'Saved to your Perfec-Tone customer profile. You were not subscribed to marketing.';
          })
          .catch(() => {
            const delivery = stage.querySelector('[data-ptq-delivery]');
            if (delivery) delivery.textContent = 'Your routine is available here. We could not confirm it was saved to your customer profile. You can still shop your routine.';
          })
          .finally(() => window.clearTimeout(timeout));
      }

      function retake() {
        Object.keys(state).forEach((key) => { state[key] = ['concerns', 'avoid_ingredients'].includes(key) ? [] : null; });
        screenHistory = [];
        sticky.hidden = true;
        sticky.classList.remove('is-visible');
        root.querySelector('.ptq__intro').hidden = false;
        root.querySelector('.ptq__privacy').hidden = false;
        root.querySelector('.ptq__progress').hidden = false;
        document.documentElement.classList.add('ptq-focus-mode');
        const url = new URL(window.location.href);
        url.searchParams.delete('r');
        window.history.replaceState({}, '', url);
        renderQuestion('goal');
        document.documentElement.style.removeProperty('overflow');
        document.body.style.removeProperty('overflow');
        document.body.classList.remove('pt-drawer-open');
        scrollToQuizTop();
      }

      const token = new URL(window.location.href).searchParams.get('r');
      if (token) {
        try {
          const normalized = token.replace(/-/g, '+').replace(/_/g, '/');
          const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, '=');
          const decoded = JSON.parse(decodeURIComponent(escape(atob(padded))));
          Object.assign(state, decoded);
          renderResult(buildResult(state), state, { revisit: true });
        } catch (error) {
          renderQuestion('goal');
        }
      } else renderQuestion('goal');
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
